<div class="flex h-screen bg-[#f1f5f9] text-slate-800 font-sans overflow-hidden">

      <aside class="w-72 bg-white border-r border-slate-200 flex flex-col shadow-sm z-20">
            <div class="p-5 border-b border-slate-100 bg-slate-50/50">
                  <div class="flex items-center space-x-3">
                        <div
                              class="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center shadow-indigo-200 shadow-md">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                              </svg>
                        </div>
                        <div>
                              <h2 class="text-xs font-bold text-slate-900 uppercase tracking-tight">SWERP Manager</h2>
                              <p class="text-[10px] text-slate-400">Meta Synchronization</p>
                        </div>
                        <button (click)="openModal()"
                              class="ml-auto flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded shadow-sm text-[10px] font-bold tracking-tight transition-all active:scale-95 leading-none uppercase">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-2.5 w-2.5" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                          d="M12 4v16m8-8H4" />
                              </svg>
                              Add Entity
                        </button>
                  </div>
            </div>

            <nav class="flex-1 overflow-y-auto p-3 space-y-1">
                  <div class="px-3 pb-2 text-[10px] font-bold text-slate-400 uppercase tracking-widest">Modules</div>
                  <button *ngFor="let ent of entitiesData" (click)="selectEntity(ent)"
                        [class.bg-indigo-50]="selectedEntity === ent" [class.text-indigo-700]="selectedEntity === ent"
                        class="w-full flex items-center px-3 py-2.5 text-xs font-semibold rounded-lg transition-all group hover:bg-slate-50">
                        <div [class.bg-indigo-600]="selectedEntity === ent"
                              class="w-1.5 h-1.5 rounded-full mr-3 bg-slate-300 transition-colors"></div>
                        {{ ent.name || 'Unnamed' }}
                  </button>
            </nav>

            <div *ngIf="loading"
                  class="p-3 bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center space-x-2">
                  <svg class="animate-spin h-3 w-3" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                        </circle>
                        <path class="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                  </svg>
                  <span>SYNCING...</span>
            </div>
      </aside>

      <main class="flex-1 flex flex-col min-w-0">
            <header
                  class="h-16 bg-white border-b border-slate-200 px-6 flex items-center justify-between shadow-sm z-10">
                  <div class="flex items-center space-x-4">
                        <h1 class="text-md font-bold text-slate-800" *ngIf="selectedEntity">
                              {{ selectedEntity.fields[0]?.entityName }} <span class="text-slate-300 mx-2">|</span>
                              <span class="text-slate-400 text-sm font-medium">Definition</span>
                        </h1>
                  </div>

                  <div class="flex items-center space-x-3">
                        <div class="bg-slate-100 p-1 rounded-lg flex border border-slate-200 shadow-inner">
                              <button (click)="jsonEditMode = false" [class.bg-white]="!jsonEditMode"
                                    [class.shadow-sm]="!jsonEditMode"
                                    class="px-4 py-1.5 text-[11px] font-bold rounded-md transition-all">Table
                                    View</button>
                              <button (click)="jsonEditMode = true" [class.bg-white]="jsonEditMode"
                                    [class.shadow-sm]="jsonEditMode"
                                    class="px-4 py-1.5 text-[11px] font-bold rounded-md transition-all">Designer</button>
                        </div>

                        <button *ngIf="!isPublished" (click)="publishEntity()" [disabled]="loading"
                              class="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1.5 rounded-lg text-[11px] font-bold shadow-md disabled:opacity-50">PUBLISH</button>

                        <!-- for a delete button wipe entity  -->
                        <button 
                              *ngIf="selectedEntity" 
                              (click)="deleteEntity()" 
                              [disabled]="loading"
                              class="bg-rose-50 hover:bg-rose-100 text-rose-600 border border-rose-200 px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all active:scale-95 disabled:opacity-50 flex items-center gap-1">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                              WIPE ENTITY
                        </button>
                        
                        <button *ngIf="jsonEditMode" (click)="saveFullJson()" [disabled]="loading"
                              class="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1.5 rounded-lg text-[11px] font-bold shadow-md disabled:opacity-50">COMMIT
                              SCHEMA</button>
                  </div>
            </header>

            <section class="flex-1 overflow-auto p-6 bg-[#f8fafc]">
                  <div *ngIf="!jsonEditMode"
                        class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        <table class="w-full text-left border-collapse">
                              <thead>
                                    <tr class="bg-slate-50 border-b border-slate-200">
                                          <th
                                                class="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-wider w-12 text-center">
                                                Seq</th>
                                          <th
                                                class="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                                                Field Meta</th>
                                          <th
                                                class="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                                                Type / Input</th>
                                          <th
                                                class="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                                                UI Config (Filter/Width)</th>
                                          <th
                                                class="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-wider w-12 text-center">
                                                Req</th>
                                          <th
                                                class="px-4 py-3 text-[10px] font-bold text-slate-400 uppercase tracking-wider text-right">
                                                Action</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let field of selectedEntity?.fields"
                                          class="hover:bg-indigo-50/30 transition-colors group">
                                          <td class="px-4 py-3 text-center text-xs font-mono text-slate-400">{{
                                                field.seq }}</td>
                                          <td class="px-4 py-3">
                                                <div class="text-xs font-bold text-slate-800">{{ field.label }}</div>
                                                <div class="text-[10px] text-slate-400 font-mono">{{ field.name }}</div>
                                          </td>
                                          <td class="px-4 py-3">
                                                <div class="flex items-center space-x-1">
                                                      <span
                                                            class="px-2 py-0.5 bg-slate-100 text-slate-600 text-[9px] font-bold rounded border uppercase">{{
                                                            field.type }}</span>
                                                      <span class="text-slate-300">/</span>
                                                      <span class="text-[10px] text-slate-500 font-medium">{{
                                                            field.inputType || 'text' }}</span>
                                                </div>
                                          </td>
                                          <!-- <td class="px-4 py-3">
                                                <div class="flex flex-col gap-1">
                                                      <div class="flex items-center gap-2">
                                                            <span class="text-[9px] font-bold px-1.5 py-0.5 rounded"
                                                                  [ngClass]="field.filter ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">FILTER:
                                                                  {{field.filter ? 'YES' : 'NO'}}
                                                            </span>
                                                            <span class="text-[9px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded font-mono"
                                                                  *ngIf="field.dialogWidth">W:
                                                                  {{field.dialogWidth}}</span>
                                                      </div>
                                                      <div class="text-[9px] text-slate-400 truncate max-w-[150px]"
                                                            *ngIf="field.filterColumns">Cols: {{field.filterColumns}}
                                                      </div>
                                                </div>
                                          </td> -->
                                          <td class="px-4 py-3">
                                                <div class="flex flex-col gap-1">
                                                      <div class="flex items-center gap-2">
                                                            <span class="text-[9px] font-bold px-1.5 py-0.5 rounded"
                                                                  [ngClass]="field['filter'] ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
                                                                  FILTER: {{field['filter'] ? 'YES' : 'NO'}}
                                                            </span>
                                          
                                                            <span class="text-[9px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded font-mono"
                                                                  *ngIf="field['dialogWidth']">
                                                                  W: {{field['dialogWidth']}}
                                                            </span>
                                                      </div>
                                          
                                                      <div class="text-[9px] text-slate-400 truncate max-w-[150px]" *ngIf="field['filterColumns']">
                                                            Cols: {{field['filterColumns']}}
                                                      </div>
                                                </div>
                                          </td>
                                          <td class="px-4 py-3">
                                                <div class="flex justify-center">
                                                      <div [class.bg-emerald-500]="field.isRequired"
                                                            [class.bg-slate-200]="!field.isRequired"
                                                            class="w-2 h-2 rounded-full shadow-inner"></div>
                                                </div>
                                          </td>
                                 
   <td class="px-4 py-3 text-right">
  <div class="flex items-center justify-end gap-2">
    <button (click)="selectField(field)"
      class="text-indigo-800 text-[10px] font-extrabold px-3 py-1.5 rounded-md bg-indigo-50 hover:bg-indigo-100 transition-all uppercase tracking-wider">
      EDIT
    </button>

    <button type="button" 
      (click)="deleteSpecificField(field); $event.stopPropagation()"
      class="flex items-center justify-center h-7 w-7 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-md transition-all border border-transparent hover:border-red-100"
      title="Delete Field">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
      </svg>
    </button>
  </div>
</td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>

                  <div *ngIf="jsonEditMode"
                        class="h-full bg-slate-900 rounded-xl overflow-hidden border border-slate-800 flex flex-col h-[400px] max-h-[300px]">
                        <div class="bg-slate-800 px-4 py-2 flex items-center justify-between">
                              <span
                                    class="text-[10px] font-mono text-slate-400 uppercase tracking-widest">editor.json (entity config)</span>
                        </div>
                        <textarea [(ngModel)]="editableEntityJsonText"
                              class="flex-1 w-full bg-transparent text-emerald-400 p-6 font-mono text-xs outline-none resize-none leading-relaxed"
                              spellcheck="false"></textarea>
                  </div>
                  <br>
                  <div *ngIf="jsonEditMode"
                        class="h-full bg-slate-900 rounded-xl overflow-hidden border border-slate-800 flex flex-col">
                        <div class="bg-slate-800 px-4 py-2 flex items-center justify-between">
                              <span
                                    class="text-[10px] font-mono text-slate-400 uppercase tracking-widest">editor.json (fields config)</span>
                        </div>
                        <textarea [(ngModel)]="editableFieldJsonText"
                              class="flex-1 w-full bg-transparent text-emerald-400 p-6 font-mono text-xs outline-none resize-none leading-relaxed"
                              spellcheck="false"></textarea>
                  </div>
            </section>
      </main>

      <div *ngIf="selectedField" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200"
                  (click)="selectedField = null"></div>

            <div
                  class="relative w-full max-w-5xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col animate-in zoom-in-95 duration-200 max-h-[95vh]">
                  <div class="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50">
                        <div>
                              <h3 class="text-sm font-bold text-slate-900">Field Configuration</h3>
                              <p class="text-[10px] text-slate-400 font-mono">{{ selectedField.fieldId }}</p>
                        </div>
                        <button (click)="selectedField = null"
                              class="p-2 hover:bg-slate-200 rounded-lg transition-colors text-slate-400">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M6 18L18 6M6 6l12 12" />
                              </svg>
                        </button>
                  </div>

                  <div class="flex-1 overflow-y-auto p-6 space-y-6">
                        <div class="grid grid-cols-4 gap-4">
                              <div class="col-span-1">
                                    <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Field Name
                                          (DB)</label>
                                    <input type="text" [(ngModel)]="selectedField.name"
                                          class="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs font-semibold outline-none focus:border-indigo-500">
                              </div>
                              <div class="col-span-1">
                                    <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">UI
                                          Label</label>
                                    <input type="text" [(ngModel)]="selectedField.label"
                                          class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-xs font-semibold outline-none focus:border-indigo-500 shadow-sm">
                              </div>
                              <div class="col-span-1">
                                    <label
                                          class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Placeholder</label>
                                    <input type="text" [(ngModel)]="selectedField.placeholder"
                                          class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-xs font-semibold outline-none focus:border-indigo-500 shadow-sm">
                              </div>
                              <div class="col-span-1 flex items-end pb-2">
                                    <label class="relative inline-flex items-center cursor-pointer">
                                          <input type="checkbox" [(ngModel)]="selectedField.isRequired"
                                                class="sr-only peer">
                                          <div
                                                class="w-9 h-5 bg-slate-200 rounded-full peer peer-checked:bg-indigo-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all">
                                          </div>
                                          <span class="ml-2 text-[11px] font-bold text-slate-600">Is Required?</span>
                                    </label>
                              </div>
                        </div>

                        <div class="p-4 bg-blue-50/50 border border-blue-100 rounded-xl">
                              <h4 class="text-[10px] font-black text-blue-600 uppercase tracking-widest mb-3">Lookup &
                                    UI Presentation</h4>
                              <!-- <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                          <label class="relative inline-flex items-center cursor-pointer mt-6">
                                                <input type="checkbox" [(ngModel)]="selectedField.filter"
                                                      class="sr-only peer">
                                                <div
                                                      class="w-9 h-5 bg-slate-200 rounded-full peer peer-checked:bg-blue-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all">
                                                </div>
                                                <span class="ml-2 text-[11px] font-bold text-slate-600">Enable Filter
                                                      (Search)</span>
                                          </label>
                                    </div>
                                    <div class="col-span-1">
                                          <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Dialog
                                                Width (e.g. 800px)</label>
                                          <input type="text" [(ngModel)]="selectedField.dialogWidth"
                                                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-xs font-semibold outline-none focus:border-blue-500">
                                    </div>
                                    <div class="col-span-1">
                                          <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Filter
                                                Columns (JSON String)</label>
                                          <input type="text" [(ngModel)]="selectedField.filterColumns"
                                                placeholder='[{"field":"name","header":"Name"}]'
                                                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-[10px] font-mono outline-none focus:border-blue-500">
                                    </div>
                              </div> -->
                              <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-1">
                                          <label class="relative inline-flex items-center cursor-pointer mt-6">
                                                <input type="checkbox" [(ngModel)]="selectedField['filter']" class="sr-only peer">
                                                <div
                                                      class="w-9 h-5 bg-slate-200 rounded-full peer peer-checked:bg-blue-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all">
                                                </div>
                                                <span class="ml-2 text-[11px] font-bold text-slate-600">Enable Filter (Search)</span>
                                          </label>
                                    </div>
                              
                                    <div class="col-span-1">
                                          <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Dialog Width (e.g. 800px)</label>
                                          <input type="text" [(ngModel)]="selectedField['dialogWidth']"
                                                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-xs font-semibold outline-none focus:border-blue-500">
                                    </div>
                              
                                    <div class="col-span-1">
                                          <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Filter Columns (JSON
                                                String)</label>
                                          <input type="text" [(ngModel)]="selectedField['filterColumns']"
                                                placeholder='[{"field":"name","header":"Name"}]'
                                                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-[10px] font-mono outline-none focus:border-blue-500">
                                    </div>
                              </div>
                        </div>

                        <div class="grid grid-cols-4 gap-4">
                              <div>
                                    <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Data
                                          Type</label>
                                    <input type="text" [(ngModel)]="selectedField.type"
                                          class="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs outline-none">
                              </div>
                              <div>
                                    <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Input
                                          Style</label>
                                    <input type="text" [(ngModel)]="selectedField.inputType"
                                          class="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs outline-none">
                              </div>
                              <div>
                                    <label
                                          class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Category</label>
                                    <input type="text" [(ngModel)]="selectedField.category"
                                          class="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs outline-none">
                              </div>
                              <div>
                                    <label
                                          class="block text-[10px] font-bold text-slate-500 uppercase mb-1">Sequence</label>
                                    <input type="number" [(ngModel)]="selectedField.seq"
                                          class="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs outline-none">
                              </div>
                        </div>

                        <div class="pt-4 border-t border-slate-100">
                              <h4 class="text-[10px] font-black text-indigo-600 uppercase tracking-widest mb-4">Advanced
                                    Logic & JSONB Blocks</h4>
                              <div class="grid grid-cols-2 gap-6">
                                    <div class="space-y-4">
                                          <div>
                                                <label
                                                      class="block text-[10px] font-bold text-slate-400 mb-1 font-mono">DataSource
                                                      (API Config)</label>
                                                <textarea [(ngModel)]="selectedField.dataSource" rows="3"
                                                      class="w-full px-3 py-2 bg-slate-900 text-emerald-400 rounded-lg font-mono text-[10px] outline-none border border-slate-800"></textarea>
                                          </div>
                                          <div>
                                                <label
                                                      class="block text-[10px] font-bold text-slate-400 mb-1 font-mono">Validators</label>
                                                <textarea [(ngModel)]="selectedField.validators" rows="2"
                                                      class="w-full px-3 py-2 bg-slate-900 text-indigo-300 rounded-lg font-mono text-[10px] outline-none border border-slate-800"></textarea>
                                          </div>
                                    </div>
                                    <div class="space-y-4">
                                          <div>
                                                <label
                                                      class="block text-[10px] font-bold text-slate-400 mb-1 font-mono">Visibility
                                                      Rule</label>
                                                <textarea [(ngModel)]="selectedField.visibility" rows="2"
                                                      class="w-full px-3 py-2 bg-slate-900 text-indigo-300 rounded-lg font-mono text-[10px] outline-none border border-slate-800"></textarea>
                                          </div>
                                          <div>
                                                <label
                                                      class="block text-[10px] font-bold text-slate-400 mb-1 font-mono">Events</label>
                                                <textarea [(ngModel)]="selectedField.events" rows="2"
                                                      class="w-full px-3 py-2 bg-slate-900 text-indigo-300 rounded-lg font-mono text-[10px] outline-none border border-slate-800"></textarea>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>

                  <div class="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center justify-end space-x-3">
                        <button (click)="selectedField = null"
                              class="px-5 py-2 text-xs font-bold text-slate-500 hover:text-slate-800 transition-colors">CANCEL</button>
                        <button (click)="saveFieldUpdate()" [disabled]="loading"
                              class="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-2 rounded-xl text-xs font-black shadow-lg shadow-indigo-100 transition-all disabled:opacity-50">UPDATE
                              REPOSITORY</button>
                  </div>
            </div>
      </div>

      <div *ngIf="isModalOpen"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div class="bg-white rounded-xl shadow-2xl w-full max-w-4xl overflow-hidden flex flex-col max-h-[90vh]">
                  <div class="px-6 py-4 border-b border-slate-100 flex justify-between items-center">
                        <div>
                              <h2 class="text-lg font-semibold text-slate-800">Add Entity Configuration</h2>
                              <p class="text-xs text-slate-500">Paste your JSON form structure below</p>
                        </div>
                        <button (click)="closeModal()" class="text-slate-400 hover:text-slate-600 transition-colors">
                              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M6 18L18 6M6 6l12 12" />
                              </svg>
                        </button>
                  </div>

                  <div class="p-6 overflow-hidden flex-1 flex flex-col bg-slate-50">
                        <textarea [(ngModel)]="newEntityJson" spellcheck="false" wrap="off"
                              class="flex-1 w-full p-4 font-mono text-sm bg-[#1e1e1e] text-[#9cdcfe] rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:outline-none overflow-auto shadow-inner min-h-[400px]"
                              placeholder='{ "entity": "name", ... }'></textarea>
                  </div>

                  <div class="px-6 py-4 border-t border-slate-100 bg-white flex justify-end gap-3">
                        <button (click)="closeModal()"
                              class="px-5 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg">Cancel</button>
                        <button (click)="submitEntity()" [disabled]="isSubmitting"
                              class="px-6 py-2 bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium rounded-lg shadow-lg">Save
                              Configuration</button>
                  </div>
            </div>
      </div>
</div>